import { types } from "../types/types";

const initialState = {
    archivosContrataciones: null,
    parametrosContrataciones: null,
    loading: false
};

export const archivosContratacionesReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.archivosContratacionesTraer:
            return {
                ...state,
                loading: true
            }
        case types.archivosContratacionesSuccess:
            return {
                ...state,
                archivosContrataciones: action.payload,
                loading: false
            }
        case types.archivosContratacionesError:
            return {
                ...state,
                archivosContrataciones: [],
                loading: false
            }
        case types.parametrosContratacionesTraer:
            return {
                ...state,
                loading: true
            }
        case types.parametrosContratacionesSuccess:
            return {
                ...state,
                parametrosContrataciones: action.payload,
                loading: false
            }
        case types.parametrosContratacionesError:
            return {
                ...state,
                parametrosContrataciones: [],
                loading: false
            }
        default:
            return state;
    }
};
